module.exports = __webpack_public_path__ + "assets/12c8d09008ae57366452c36b16b7eb2f.mp3";